module.exports = __webpack_public_path__ + "static/ntu-1f71ab6061448130939f14170949874a.jpg";